import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, ChartBarIcon, PencilIcon } from '@heroicons/react/24/outline';
import Card, { CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Badge from '@/components/ui/Badge';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeaderCell,
  TableCell,
} from '@/components/ui/Table';

// Mock data
const mockPublishers = [
  {
    id: 1,
    name: 'Éditions Kampus',
    books: 156,
    published: 142,
    pending: 12,
    failed: 2,
    status: 'active',
    created_at: '2023-06-15',
  },
  {
    id: 2,
    name: 'Voyage Plus',
    books: 43,
    published: 38,
    pending: 4,
    failed: 1,
    status: 'active',
    created_at: '2023-08-20',
  },
  {
    id: 3,
    name: 'TechLib',
    books: 44,
    published: 40,
    pending: 3,
    failed: 1,
    status: 'paused',
    created_at: '2023-09-10',
  },
  {
    id: 4,
    name: 'Cuisine Éditions',
    books: 28,
    published: 28,
    pending: 0,
    failed: 0,
    status: 'active',
    created_at: '2023-11-01',
  },
];

export default function DistPublishersPage() {
  const [_showAddModal, setShowAddModal] = useState(false);

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Page Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Publishers</h1>
          <p className="text-slate-500 mt-1">Manage publisher accounts and configurations</p>
        </div>
        <Button leftIcon={<PlusIcon className="w-4 h-4" />} onClick={() => setShowAddModal(true)}>
          Add Publisher
        </Button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card>
          <CardBody className="text-center">
            <p className="text-3xl font-bold text-slate-800">{mockPublishers.length}</p>
            <p className="text-sm text-slate-500">Total Publishers</p>
          </CardBody>
        </Card>
        <Card>
          <CardBody className="text-center">
            <p className="text-3xl font-bold text-success-500">
              {mockPublishers.filter((p) => p.status === 'active').length}
            </p>
            <p className="text-sm text-slate-500">Active</p>
          </CardBody>
        </Card>
        <Card>
          <CardBody className="text-center">
            <p className="text-3xl font-bold text-slate-800">
              {mockPublishers.reduce((sum, p) => sum + p.books, 0)}
            </p>
            <p className="text-sm text-slate-500">Total Books</p>
          </CardBody>
        </Card>
        <Card>
          <CardBody className="text-center">
            <p className="text-3xl font-bold text-primary-500">
              {mockPublishers.reduce((sum, p) => sum + p.published, 0)}
            </p>
            <p className="text-sm text-slate-500">Published</p>
          </CardBody>
        </Card>
      </div>

      {/* Publishers Table */}
      <Card padding="none">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow isHoverable={false}>
                <TableHeaderCell>Publisher</TableHeaderCell>
                <TableHeaderCell>Total Books</TableHeaderCell>
                <TableHeaderCell>Published</TableHeaderCell>
                <TableHeaderCell>Pending</TableHeaderCell>
                <TableHeaderCell>Failed</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Actions</TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mockPublishers.map((publisher) => (
                <TableRow key={publisher.id}>
                  <TableCell>
                    <Link
                      to={`/distribution/publishers/${publisher.id}`}
                      className="font-medium text-slate-800 hover:text-primary-500"
                    >
                      {publisher.name}
                    </Link>
                  </TableCell>
                  <TableCell className="text-slate-600">{publisher.books}</TableCell>
                  <TableCell className="text-success-600">{publisher.published}</TableCell>
                  <TableCell className="text-warning-600">{publisher.pending}</TableCell>
                  <TableCell className="text-danger-600">{publisher.failed}</TableCell>
                  <TableCell>
                    <Badge variant={publisher.status === 'active' ? 'success' : 'warning'}>
                      {publisher.status}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      <Link to={`/distribution/publishers/${publisher.id}`}>
                        <Button variant="ghost" size="sm" leftIcon={<PencilIcon className="w-3 h-3" />}>
                          Edit
                        </Button>
                      </Link>
                      <Button variant="ghost" size="sm" leftIcon={<ChartBarIcon className="w-3 h-3" />}>
                        Stats
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </div>
  );
}

